import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

export const getFindReplaceOptions: MemoizedFn<
	() => {
		allowMatchCase: boolean;
	}
> = memoizeOne(
	(): {
		allowMatchCase: boolean;
	} => {
		return { allowMatchCase: true };
	},
);
